<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header" i18n="@@addToFavourites">Add to favourites</h3>
    <button
      type="button"
      class="close"
      attr.aria-label="Close Add to favourites Modal"
      ngbAutoFocus
      i18n-aria-label
      (click)="closeModal()"
    >
      <span aria-hidden="true">
        <i class="ico-cancel modal_exit_cross"></i>
      </span>
    </button>
  </div>
  <div class="modal-body">
    <label i18n="@@addToFavoritesPlease" for="add-to-favourites-input-name"
      >Please enter a name for your favourite journey:</label
    >
    <input
      appInput
      [border]="true"
      [noIcon]="true"
      [(ngModel)]="name"
      id="add-to-favourites-input-name"
    />
  </div>
  <div class="modal-footer">
    <button
      type="button"
      id="add-to-favorites-button-save"
      class="modal_button_okay"
      (click)="save(name)"
      [disabled]="!name"
      i18n="@@addToFavouritesSave"
    >
      Save
    </button>
  </div>
</div>
